import { useEditorContext } from '../editor_context';
import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
   Table,
   FeaturedQuote,
   Note,
   Grid,
} from '../extensions';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { TextStyleDropdown } from '../components/TextStyleDropdown';
import { VideoInsertDropdown } from '../components/VideoInsertDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   CodeBlockButton,
   BlockquoteButton,
   NoteDropdown,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
   UndoButton,
   RedoButton,
   InsertImageButton,
   GridDropdown,
   GridAddColumnButton,
   GridRemoveColumnButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const WikiExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
   Table,
   FeaturedQuote,
   Note,
   Grid,
];

export const WikiMenuBar = (_props: any) => {
   const canIUseGridTools = App.canIUseGridTools;

   return (
      <TiptapMenubar>
         <BoldButton />
         <ItalicButton />
         <CodeButton />
         <LinkButton />
         <MenuSeparator />
         <TextStyleDropdown />
         <MenuSeparator />
         <CodeBlockButton />
         <BlockquoteButton />
         <NoteDropdown />
         <BulletListButton />
         <OrderedListButton />
         <UnindentButton />
         <IndentButton />
         {canIUseGridTools && (
            <>
               <MenuSeparator />
               <GridTools />
            </>
         )}
         <MenuSeparator />
         <InsertImageButton />
         <VideoInsertDropdown />
         <MenuSeparator />
         <UndoButton />
         <RedoButton />
      </TiptapMenubar>
   );
};

function GridTools() {
   const gridColumns = useGridColumns();
   const showGridTools = gridColumns !== null;
   if (!showGridTools) {
      return <GridDropdown />;
   }

   return (
      <>
         <GridDropdown />
         <GridAddColumnButton />
         <GridRemoveColumnButton />
      </>
   );
}

function useGridColumns() {
   const { editor } = useEditorContext();

   if (!editor.isActive('grid')) {
      return null;
   }

   return editor.getAttributes('grid')?.columns;
}
